import React, { Dispatch, ReactElement, SetStateAction } from 'react';
import './notifikaciaHistoriaActions.scss';
import { NotifikaciaTypEnum } from '../../../../model/notifikacia/NotifikaciaTyp';
import NotifikaciaHistoriaDialog from './NotifikaciaHistoriaDialog';
import Uuid from '../../../../model/Uuid';

interface Props {
  notifikaciaActions: Array<NotifikaciaTypEnum>;
  materialUuid: Uuid,
  reloadNotifikaciaHistoria: () => void;
  setSendNotificationLoading: Dispatch<SetStateAction<boolean>>;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
}

const NotifikaciaHistoriaActions = ({
  notifikaciaActions,
  materialUuid,
  reloadNotifikaciaHistoria,
  setSendNotificationLoading,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const getNotifikaciaAction = (notifikaciaAction: NotifikaciaTypEnum): ReactElement => {
    switch (notifikaciaAction) {
      case NotifikaciaTypEnum.SPUSTENIE_MPK:
        return (
          <NotifikaciaHistoriaDialog
            key={notifikaciaAction}
            confirmActionQuestion="Naozaj si prajete odoslať notifikácie o spustení PK pre zvolený proces?"
            reloadNotifikaciaHistoria={reloadNotifikaciaHistoria}
            openButtonDescription="Zaslať notifikáciu o spustení PK"
            materialUuid={materialUuid}
            notificationType={notifikaciaAction}
            setSendNotificationLoading={setSendNotificationLoading}
            setIsDropdownOpened={setIsDropdownOpened}
          />
        );
      case NotifikaciaTypEnum.ZRUSENIE_MPK:
        return (
          <NotifikaciaHistoriaDialog
            key={notifikaciaAction}
            confirmActionQuestion="Naozaj si prajete odoslať notifikácie o zrušení PK pre zvolený proces?"
            reloadNotifikaciaHistoria={reloadNotifikaciaHistoria}
            openButtonDescription="Zaslať notifikáciu o zrušení PK"
            materialUuid={materialUuid}
            notificationType={notifikaciaAction}
            setSendNotificationLoading={setSendNotificationLoading}
            setIsDropdownOpened={setIsDropdownOpened}
          />
        );
      case NotifikaciaTypEnum.ZACIATOK_AKT_EU:
        return (
          <NotifikaciaHistoriaDialog
            key={notifikaciaAction}
            confirmActionQuestion="Naozaj si prajete odoslať notifikácie o začatí Aktu EÚ pre zvolený proces?"
            reloadNotifikaciaHistoria={reloadNotifikaciaHistoria}
            openButtonDescription="Zaslať notifikáciu o začatí Aktu EÚ"
            materialUuid={materialUuid}
            notificationType={notifikaciaAction}
            setSendNotificationLoading={setSendNotificationLoading}
            setIsDropdownOpened={setIsDropdownOpened}
          />
        );
      default:
        return null;
    }
  };

  if (notifikaciaActions && notifikaciaActions.length === 0) {
    return null;
  }

  return notifikaciaActions && (
  <div className="notifikacia-historia-admin">
    {notifikaciaActions.map((notifikaciaAction) => getNotifikaciaAction(notifikaciaAction))}
  </div>
  );
};
export default NotifikaciaHistoriaActions;
